import { FilterSchema } from '../../../../../core/base/interfaces/filter-schema.interface';
import { EstablishmentService } from '../../establishment/establishment.service';
import { SupplierService } from '../../supplier/supplier.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { ActivityTypeService } from '../../../settings/activity-type/activity-type.service';
import { ActivityTypeModel } from '../../../../../core/models/activity-type.model';

/** Libellé d'une activité dans le filtre : « ACR - Libellé » quand l'acronyme existe. */
export const toActivityOption = (activityType: ActivityTypeModel) => ({
  ...activityType,
  label: activityType.acronym ? `${activityType.acronym} - ${activityType.label}` : activityType.label,
});

export const CONTRACT_FILTER_SCHEMA: FilterSchema = {
  technicalIdentifier: { type: 'text' },
  // Valeurs distinctes projetées (pas des entités) : la chip est la référence elle-même
  supplierContractRef: { type: 'value[]', valueField: 'supplierContractReference' },
  establishments: { type: 'entity[]', resolve: { service: EstablishmentService, displayProperty: 'label' } },
  activities: {
    type: 'entity[]',
    resolve: { service: ActivityTypeService, displayProperty: 'label', map: toActivityOption },
  },
  suppliers: { type: 'entity[]', resolve: { service: SupplierService, displayProperty: 'label' } },
  referentUserIds: {
    type: 'entity[]',
    control: 'businessReferentUsers',
    resolve: { service: UserProfileService, key: 'businessReferentUsers', displayProperty: 'fullName' },
  },
  // Liste filtrée selon le rôle (DRAFT réservé aux référents engagement)
  status: { type: 'option[]', options: 'contractStatusOptions' },
  startValidityDate: { type: 'range', form: 'applicationPeriodForm' },
  endValidityDate: { type: 'range', form: 'endApplicationPeriodForm' },
  noticeDate: { type: 'range', form: 'noticePeriodForm' },
  revisionDate: { type: 'range', form: 'revisionPeriodForm' },
  // Radio Contrat/Devis de la liste, hors sidenav : persisté dans l'URL, dérivé en genericEngagementFormat(Exclude)
  engagementType: { type: 'text' },
};
